var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActionEdit = function SvgActionEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.996 5.112a.88.88 0 0 1-.271.664l-8.068 8.07a1 1 0 0 1-.365.233l-2.746 1a.5.5 0 0 1-.64-.644l1.018-2.728a1 1 0 0 1 .23-.358l8.068-8.07a.89.89 0 0 1 .67-.272c.468.026 1.233.125 1.608.493.376.369.473 1.142.496 1.612m-1.086-.603c.047.188.072.399.083.585L11.95 13.14l-1.728.63.639-1.714 8.043-8.046c.186.013.396.038.585.086.217.054.3.11.31.118l.002.003c.01.016.06.097.11.292Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.5A1.5 1.5 0 0 1 5.5 6H12V5H5.5A2.5 2.5 0 0 0 3 7.5v11.006a2.5 2.5 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5v-6.503h-1v6.503a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5z"
  })));
};
export default SvgActionEdit;